import * as THREE from 'three';

/**
 * Single clock instance for the entire application.
 * getDelta() is called ONCE per frame in the main loop and passed to all systems.
 */
class AppClock {
  private clock = new THREE.Clock();

  getDelta(): number {
    return this.clock.getDelta();
  }

  getElapsedTime(): number {
    return this.clock.getElapsedTime();
  }
}

export const appClock = new AppClock();
